module.exports = __webpack_public_path__ + "static/img/digitization3.380fba6f.png";